module.exports = __webpack_public_path__ + "img/mobileparty1.657a1f3e.png";